module.exports = __webpack_public_path__ + "img/valentine-light-small.7b6d88c4.svg";